import Link from "next/link";
import { StaticImageData } from "next/image";
import AmdLogo from "public/pricing/amd.webp";
import IntelLogo from "public/pricing/intel.png";
import { scrollToElement } from "@/utils/scrollToElement";

type BareMetalServerData = {
  sku: string;
  image: StaticImageData;
  processor: string;
  memory: string;
  baseclock_boost: string;
  disk: string;
  bootDrives: string;
  price: string;
};

export const BAREMETAL_SERVER_DATA: BareMetalServerData[] = [
  {
    sku: "OMS-SC1-GP1",
    image: IntelLogo,
    processor: "2 X Intel Gold 6138 40C | 80T",
    memory: "512GB",
    baseclock_boost: "2.00 GHz | 3.70 GHz",
    disk: "2 X 1.9TB SSD",
    bootDrives: "NA",
    price: "₹65,250",
  },
  {
    sku: "OMS-SC1-GP3",
    image: IntelLogo,
    processor: "2X Intel Xeon Silver 4314 32C | 64T",
    memory: "512GB",
    baseclock_boost: "2.4 GHz | 3.4 GHz",
    disk: "2 X 3.84TB NVME",
    bootDrives: "2 X 240 GB",
    price: "₹69,600",
  },
  {
    sku: "OMS-SC2-HC2",
    image: IntelLogo,
    processor: "2 X Intel Gold 8268 48C | 96T",
    memory: "1024GB",
    baseclock_boost: "2.90 GHz | 3.90 GHz",
    disk: "6 X 7.68TB NVME",
    bootDrives: "2 X 240 GB",
    price: "₹1,26,150",
  },
  {
    sku: "OMS-SC2-HC3",
    image: IntelLogo,
    processor: "2X Intel Xeon Gold 6544Y 32C | 64T",
    memory: "2048GB",
    baseclock_boost: "3.6 GHz | 4.1GHz",
    disk: "8 X 7.68TB NVME",
    bootDrives: "2 X 480 GB",
    price: "₹1,60,950",
  },
  {
    sku: "AMD EPYC3 HC1",
    image: AmdLogo,
    processor: "AMD EPYC 7313 - 16C | 32T",
    memory: "256GB",
    baseclock_boost: "3.0 GHz | 3.7GHz",
    disk: "1.92TB NVME",
    bootDrives: "2 X 240 GB",
    price: "₹58,725",
  },
  {
    sku: "AMD EPYC2-HC3",
    image: AmdLogo,
    processor: "2 X AMD EPYC 7532 64C | 128T",
    memory: "512GB",
    baseclock_boost: "2.4 GHz | 3.3 GHz",
    disk: "4 X 3.84TB NVME",
    bootDrives: "2 X 240 GB",
    price: "₹50,025",
  },
  {
    sku: "AMD EPYC2-HC4",
    image: AmdLogo,
    processor: "2 X AMD EPYC 9354 64C | 128T",
    memory: "1024GB",
    baseclock_boost: "3.25 GHz | 3.75 GHz",
    disk: "6 X 7.68TB NVME",
    bootDrives: "2 X 480 GB",
    price: "₹1,39,113",
  },
  {
    sku: "OMS-RYZENTR-1",
    image: AmdLogo,
    processor: "AMD TR PRO 7965WX 24C | 48T",
    memory: "512GB",
    baseclock_boost: "4.2 GHz | 5.3 GHz",
    disk: "2 X 2TB",
    bootDrives: "2 X 512 GB",
    price: "₹78,213",
  },
];

export const TableFooter = {
  text1: (
    <>
      We have more servers for your business. Prices are estimates and may vary hourly,
      monthly, or yearly as per your needs. Please Contact{" "}
      <Link
        href="#contact-us"
        onClick={(e) => {
          e.preventDefault();
          scrollToElement("contact-us", 120);
        }}
        target="_blank"
        style={{
          textDecoration: "underline",
          color: "#1E87F0",
          fontWeight: 700,
        }}
      >
        sales
      </Link>{" "}
      for more information.
    </>
  ),
  text2: {
    title: "Need help choosing the right server?",
    content:
      "Our experts are available 24/7 to help you choose the right server for your needs.",
    button: {
      label: "Contact us",
      link: "#contact",
    },
  },
};
